import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { createNlsMiddleware } from 'lcc-state';
import { LearningActivity } from '@holmescorp/learning-activity';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const nls = createNlsMiddleware('activities');
const factory = create({ theme, nls }).properties();
export const Storyline = factory(({ properties, middleware: { theme, nls } }) => {
    const { topicdata, additionalClasses = [] } = properties();
    const themeCss = theme.classes(css);
    const data = topicdata;
    const { messages } = nls();
    const { attributes = { id: '' } } = data;
    const { portal_userid: uid, sessionid } = window.hcstatic;
    const storyline = messages[`storyline_${attributes.id}`];
    const title = messages[`storyline_title_${attributes.id}`];
    const index = messages[`storyline_index_file`] || 'index_lms.html';
    const endpoint = encodeURIComponent(`${window.hcstatic.portal_url}/@@lrs/xapi/`);
    const actor = encodeURIComponent(`{"objectType":"Agent","name":"${uid}","mbox":"mailto:${uid}@example.com|${sessionid}"}`);
    const auth = encodeURIComponent(`Bearer ${window.hcstatic.xapi_token}`);
    const risepath = `${window.hcstatic.portal_cdn}/files/storyline/${storyline}/${index}`;
    const queryparams = `?endpoint=${endpoint}&actor=${actor}&auth=${auth}`;
    const url = `${risepath}${queryparams}`;
    return v('div', { classes: [themeCss.storyline, ...additionalClasses] }, [
        storyline
            ? w(LearningActivity, {
                activityname: `storyline-${storyline}`,
                url,
                title,
                checkSize: false
            })
            : null
    ]);
});
